const paymentMethods = (payment_method) => {
    let label = '';

    switch (parseInt(payment_method, 10)) {
        case 1:
            label = 'Credit / Debit';
            break;
        case 2:
            label = 'Paypal';
            break;
        case 3:
            label = 'Over-the-counter/bank';
            break;
        case 4:
            label = 'GCash';
            break;
        case 5:
            label = 'Credit / Debit (Paynamics)';
            break;
        default:
            return;
    }

    return label;
}

const paymentType = (payment_type) => {
    let label = '';

    switch (parseInt(payment_type, 10)) {
        case 1:
            label = 'One-Time';
            break;
        case 2:
            label = 'Recurring';
            break;
        default:
            return;
    }

    return label;
}

const paymentFrequency = (payment_frequency, defaults = '') => {
    let label = '';

    switch (parseInt(payment_frequency, 10)) {
        case 1:
            label = 'one-time';
            break;
        case 2:
            label = 'monthly';
            break;
        case 3:
            label = 'quarterly';
            break;
        case 4:
            label = 'semi-annually';
            break;
        case 5:
            label = 'annually';
            break;
        default:
            label = defaults;
    }

    return label;
}

const paymentStatus = (status) => {
    let label = '';

    switch (status) {
        case 1:
            label = 'not complete';
            break;
        case 2:
            label = 'complete';
            break;
        case 3:
            label = 'fail/canceled';
            break;
        default:
            return;
    }

    return label;
}

const childStatus = (status) => {
    let label = '';

    switch (status) {
        case 1:
            label = 'available';
            break;
        case 2:
            label = 'hidden';
            break;
        case 3:
            label = 'requested';
            break;
        case 4:
            label = 'sponsored';
            break;
        default:
            label = '..blank..';
    }

    return label;
}

const eventStatus = (status) => {
    let label = '';

    switch (status) {
        case 'active':
            label = 'Active';
            break;
        case 'draft':
            label = 'Draft';
            break;
        case 'completed':
            label = 'Completed';
            break;
        case 'postponed':
            label = 'Postponed';
            break;
        case 'cancelled':
            label = 'Cancelled';
            break;
        default:
            return;
    }

    return label;
}

const enums = {
    paymentMethods,
    paymentFrequency,
    paymentStatus,
    paymentType,
    childStatus,
    eventStatus
}

export default enums